import { css } from '@linaria/core';
import { buildTheme } from '../themeBuilder';
import { themeArdDarkArdCss } from '@ard-online/figma-design-system-values';
import { THEME_ID_TYPES, THEME_LAYOUT_TYPES, THEME_NAME_TYPES } from '../types';
export const defaultColors = {
    globalBackground: '0,14,41',
    globalBackground2: '36,51,80',
    globalBackground3: '254,190,0',
    globalSurface: '36,51,80',
    globalSurface2: '51,66,96',
    globalVariant: '0,30,80',
    globalVariant2: '0,52,128',
    globalText: '255,255,255',
    globalText2: '255,255,255',
    globalText3: '90,25,156',
    globalShadow: '0,14,41',
    globalSuccess: '131,207,146',
    globalError: '253,79,92',
    brandDark: '0,113,238',
    brandDarkText: '255,255,255',
    brandDark2: '45,145,255',
    brandText2: '255,255,255',
    brandLive: '253,79,92',
};
export default {
    id: THEME_ID_TYPES.DARK_ARD,
    name: THEME_NAME_TYPES.ARD,
    layout: THEME_LAYOUT_TYPES.ADULT,
    base: css `
		${buildTheme({ cssVariables: themeArdDarkArdCss, colors: defaultColors })}
	`,
};
